const header = "[Jabra]";

const timestampConfig = {
  hour12: false,
  hour: "2-digit",
  minute: "2-digit",
  second: "2-digit",
  fractionalSecondDigits: 3,
};

const headerFactory = {
  toString: function () {
    const timestamp = new Date().toLocaleTimeString([], timestampConfig);
    return `${header} ${timestamp}`;
  },
};

const defaultLogger = {
  debug: console.log.bind(console, "%s", headerFactory),
  info: console.info.bind(console, "%s", headerFactory),
  warn: console.warn.bind(console, "%s", headerFactory),
  error: console.error.bind(console, "%s", headerFactory),
};

export default defaultLogger;
